import { NgModule } from '@angular/core';

import { provideFormlyConfig } from '@ngx-formly/core';

import { DateTimeFormFieldUiComponent } from './date-time-form-field-ui/date-time-form-field-ui.component';

@NgModule({
  imports: [DateTimeFormFieldUiComponent],
  exports: [DateTimeFormFieldUiComponent],
  providers: [
    provideFormlyConfig({
      types: [
        {
          name: 'date-time',
          component: DateTimeFormFieldUiComponent,
        },
      ],
    }),
  ],
})
export class SharedFormUiDateTimeModule {}
